import { RecordDto } from "@/core/common/entities/record.dto";
import { getPurchaseOrderStatusLabel, PurchaseOrderStatusEnum } from "@altertec_gparn/lib";
import { get } from "lodash";
import { purchaseOrderTranslate } from "@/core/features/purchase-orders/purchase-order.translate";
import { toEuros } from "@/utils/numberUtils";

export class PurchaseOrderRecordDto extends RecordDto {
  purchaseOrderId: string;
  translateEntityName = "el pedido";
  translateKeys = {
    ...purchaseOrderTranslate,
  };

  getTargetField(): string {
    if (!this.targetField) return;
    return get(this.translateKeys, this.targetField, this.targetField);
  }

  transformFn(value: unknown, originalValue: unknown): string {
    if (this.targetField === "status") {
      return getPurchaseOrderStatusLabel(value as PurchaseOrderStatusEnum);
    }

    if (["totalAmount", "unitPrice"].includes(this.targetField)) {
      return value && !isNaN(Number(value)) ? `${toEuros(Number(value))}€` : "0€";
    }

    return super.transformFn(value, originalValue);
  }

  getSubtype(): string {
    return this.subtype;
  }
}
